//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/TaggedObject.js";
let d=[[[0,"Value",1,0]],[[["count"],"GetOptionValues",{R_:{values:""}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.ShipDesign.ShipNameFieldBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ShipNameFieldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ShipnameFieldBuilderType = Object.freeze({
    "Fixed" : "Fixed", "Option" : "Option", "Index" : "Index", "Any" : "Any", "PositionInformation" : "PositionInformation", "ContextAttributeMap" : "ContextAttributeMap", "SectionInformation" : "SectionInformation", "AttributeMap" : "AttributeMap", "ParentPartPosition" : "ParentPartPosition", "FrameName" : "FrameName", "PortOrStarboard" : "PortOrStarboard", "DirectionInformation" : "DirectionInformation", "SmartFixed" : "SmartFixed", "Tcid" : "Tcid", "TcidFixed" : "TcidFixed", "TcidIndex" : "TcidIndex", "None" : "None"});

export default SPLM;